import { useMemo } from 'react';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { mergeInitialValues } from '@utils/formik';
import { useFormSchema, useFormValues } from '../InsurancePolicyBuyForm';

export const useInitialValues = (policy?: InsurancePolicy | null) => {
  const values = useFormValues();
  return useMemo(() => mergeInitialValues(values, policy), [policy]);
};

export const useValidationSchema = useFormSchema;
